<template>
  <div class="wrapContainer">
    <Header :menu-list="menuTop"></Header>
    <div class="homeContainer">
        <router-view></router-view>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from '@/components/pc/headPart.vue'
  import Footer from '@/components/pc/footPart.vue'
  import axios from 'axios'
    export default {
        name: "index",
        components: {
          Header,
          Footer
        },
        data () {
          return{
            token: '',
            baseurl: 'https://org.api.lotusdata.com/',
            menuList: [],
            menuTop: []
          }
        },
        methods: {
          setTopMenu() {
            let self = this;

            self.menuList.forEach((item) => {
              if (item.top === "1") {
                self.menuTop.push({
                  title: item.title,
                  pid: item.pid,
                  id: item.id,
                  top: item.top,
                  children: item.children,
                  dtype: item.dtype,
                  Showstyle: item.Showstyle,
                  newslink: item.newslink,
                });
              }
            });
            console.log(self.menuTop, '富')
          },
          filterData(data) {
            let self = this;
            self.menuList.forEach((child, index) => {
              data.filter((item) => {
                if (item.Pid == child.id) {
                  if (item.Top === "1") {
                    self.menuList[index].children.push({
                      title: item.Name,
                      pid: item.Pid,
                      id: item.Id,
                      top: item.Top,
                      dtype: item.DType,
                      Showstyle: item.Showstyle,
                      newslink: item.NewsLink,
                    });
                  }
                }
              });
            });
            self.setTopMenu();
          },
          filterParent(data) {
            let self = this;
            var id = "";
            var temp = [];
            data.filter((item) => {
              if (item.Pid == "") {
                id = item.Id;
              }
            });
            data.filter((item) => {
              if (item.Pid == id) {
                temp.push({
                  title: item.Name,
                  pid: item.Pid,
                  id: item.Id,
                  dtype: item.DType,
                  Showstyle: item.Showstyle,
                  newslink: item.NewsLink,
                  order: item.Orderindex,
                  index: parseInt(item.Orderindex),
                  top: item.Top,
                  children: [],
                });
              }
            });
            data.forEach((item) => {
              item.OrderNumber =  item.Orderindex ? parseInt(item.Orderindex) : 0
            })
            for (let i = 0; i < temp.length; i++) {
              for (let j = i + 1; j < temp.length; j++) {
                if (temp[j].index < temp[i].index) {
                  var middle = temp[i];
                  temp[i] = temp[j];
                  temp[j] = middle;
                }
              }
            }
            self.menuList = temp;
            data.sort((a,b)=>{ // 根据序号排序小序号在前大序号在后
                return( a.OrderNumber - b.OrderNumber)
            })
            self.filterData(data);
          },
          getmenuList () {
            let self = this
            axios.get(this.baseurl + "operations/v1/column/list?offset=0&limit=1000",{
              headers: {'Authorization': this.token}
            }).then(
              function (res) {
                console.log('获取栏目列表2', res)
                if(res.data.code == "0"){
                  var data = res.data.data
                  self.filterParent(data)
                }else if(res.data.code == '-2'){
                  self.refreshToken(self.token)
                }
              },function (err) {
                self.$Message.error(err);
              }
            )
          },
          refreshToken (oldToken) {
            if(oldToken != null){
                let token = oldToken.slice(4),
                    that = this;
                axios.post(that.baseurl + 'operations/v1/admlogin/refreshtoken', {"token": token}, {headers: {Authorization: oldToken}}).then(res => {
                    if (res.data.code == '0') {
                        var newToken = 'JWT ' + res.data.token;
                        that.token = newToken;
                        that.getmenuList()
                    }
                })
                }else{
                    this.$axios.get("https://api.lotusdata.com/v1/buser/token", {
                        params: {
                            username:"system@akso.com",
                            password:"123123",
                            refreshtoken:'0'
                        }}).then(res => {
                                if (res.data.code == 0) {
                                var TOKEN = res.data.token;
                                localStorage.setItem("TOKEN", "JWT " + TOKEN);
                                that.getmenuList()
                              }
                        },);
                }
        },
        },
        mounted () {
          console.log('22222222')
          this.$nextTick(() => {
            this.token = localStorage.getItem('token')
            this.getmenuList()
          })
        }
    }
</script>

<style lang="less" scoped>
  @baseBase: #eaf0eb;
  @base: #3e8f83;
  @pcWidth: 1230px;
  @padWidth: 982px;

  .wrapContainer{
    width:100%;
    display: block;
    height: auto;
  }
  .homeContainer{
    width:@pcWidth;
    height: auto;
    margin:30px auto;
  }
  @media screen and (max-width:1260px){
    .homeContainer{
      width:@padWidth;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/pcHome/main.vue